// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"comment-view_shadow__1tMMK","comment":"comment-view_comment__2Sqae","user":"comment-view_user__NszJP"};